import{_ as r}from"./_getNative-9aa37f67.js";var t=function(){try{var t=r(Object,"defineProperty");return t({},"",{}),t}catch(r){}}();export{t as _};
//# sourceMappingURL=_defineProperty-488d86ef.js.map
